// Customer-service LINE link for membership activation. Membership is activated
// by contacting support (not self-serve billing). Paste the official LINE URL
// here when ready — the "聯繫客服開通" buttons will then jump straight to it;
// until then they show a "LINE 即將提供" notice.
export const SUPPORT_LINE_URL = 'https://lin.ee/ZjrkaTo';
